import config from "@/config"
import * as _ from "lodash-es";
import http from "@/utils/request"

export default {
  initVersion: {
    url: `${config.API_URL}/lqa-game/system/version/initVersion`,
    name: "获取产品列表",
    post: function (projectNum) {
      return http.post(this.url, void 0, {params: {projectNum}});
    }
  },
  getAllQuestion: {
    url: `${config.API_URL}/lqa-game/system/question/mould/allQuestion`,
    name: "获取问题列表",
    get: function (versionNum) {
      return http.get(this.url, {versionNum});
    }
  },
  addVersionInfo: {
    url: `${config.API_URL}/lqa-game/system/version`,
    name: "提交版本",
    post: function (data) {
      return http.post(this.url, data);
    }
  },
  updateVersionInfo: {
    url: `${config.API_URL}/lqa-game/system/version`,
    name: "更新版本",
    put: function (data) {
      return http.put(this.url, data);
    }
  },
  getMyProVersion: {
    url: `${config.API_URL}/lqa-game/system/version/getProVersion`,
    name: "获取任务附件信息",
    get: function () {
      return http.get(this.url);
    }
  },
  getProVersionInfo: {
    url: `${config.API_URL}/lqa-game/system/version/byVersionNum`,
    name: "根据版本ID获取项目信息",
    get: function (versionNum) {
      return http.get(this.url, {versionNum});
    }
  },
  getVersionInfo: {
    url: `${config.API_URL}/lqa-game/system/version/byprojectNum`,
    name: "根据项目ID获取项目信息",
    get: function (projectNum) {
      return http.get(this.url, {projectNum});
    }
  },
  saveAllQustion: {
    url: `${config.API_URL}/lqa-game/system/question/mould/submitQuestion`,
    name: "获取产品列表",
    post: function (data) {
      return http.post(this.url, data);
    }
  },
  getVersionModule: {
    url: `${config.API_URL}/lqa-game/system/modular/queryModular`,
    name: "获取版本模板",
    get: function (versionNum) {
      return http.get(this.url, {versionNum});
    }
  },
  // 获取表格历史数据
  getExcelData: {
    get: function (versionNum) {
      return http.get("/lqa-game/system/test/getExcelData", {versionNum});
    }
  },
  getModuleById: {
    url: `${config.API_URL}/lqa-game/system/modular/`,
    name: "获取版本模板",
    get: function (moduleName) {
      return http.get(this.url + moduleName);
    }
  },
  getVersionModualParent: {
    url: `${config.API_URL}/lqa-game/system/modular/queryParentModular`,
    name: "获取父元素模块",
    get: function (versionNum) {
      return http.get(this.url, {versionNum});
    }
  },
  getVersionModualList: {
    url: `${config.API_URL}/lqa-game/system/modular/list`,
    name: "获取版本模板",
    get: function (query) {
      return http.get(this.url, query);
    }
  },
  addVersionModual: {
    url: `${config.API_URL}/lqa-game/system/modular`,
    name: "获取父元素模块",
    post: function (data) {
      return http.post(this.url, data);
    }
  },
  updateVersionModual: {
    url: `${config.API_URL}/lqa-game/system/modular`,
    name: "获取父元素模块",
    put: function (data) {
      return http.put(this.url, data);
    }
  },
  deleteVersionModual: {
    url: `${config.API_URL}/lqa-game/system/modular/`,
    name: "获取父元素模块",
    delete: function (moduleName) {
      return http.delete(this.url + moduleName);
    }
  },
  getAllVersionModual: {
    url: `${config.API_URL}/lqa-game/system/modular/getAllIds`,
    name: "获取版本模板id和父元素Id",
    get: function (versionNum) {
      return http.get(this.url, {versionNum});
    }
  },
  useHisVerModule: {
    url: `${config.API_URL}/lqa-game/system/version/useVerHisModual`,
    name: "复用历史版本信息",
    get: function (versionNum, nowVersionNum) {
      return http.get(this.url, {versionNum, nowVersionNum});
    }
  },
  getAllModularIdNames: {
    url: `${config.API_URL}/lqa-game/system/modular/getAllModularNames`,
    name: "获取版本模板id和父元素Id",
    get: function (versionNum) {
      return http.get(this.url, {versionNum});
    }
  },

  getTastCaseList: {
    url: `${config.API_URL}/lqa-game/system/testcase/list`,
    name: "获取测试用例列表",
    get: function (query) {
      return http.get(this.url, query);
    }
  },
  addTestCase: {
    url: `${config.API_URL}/lqa-game/system/testcase`,
    name: "添加测试用例",
    post: function (data) {
      return http.post(this.url, data);
    }
  },
  updateTestCase: {
    url: `${config.API_URL}/lqa-game/system/testcase`,
    name: "修改测试用例",
    put: function (data) {
      return http.put(this.url, data);
    }
  },
  getTestCase: {
    name: "删除测试用例",
    get: function (list) {
      const url = `${config.API_URL}/lqa-game/system/testcase/`;
      const array = _.map(_.concat([], list), async function(value) {
        try {
          if (value) {
            const res = await http.get(url + value);
            if (res && res.code === 200) {
              return res.data;
            }
          }
        } catch (e) {
          // todo
        }
      });
      return Promise.all(_.compact(array));
    }
  },
  deleteTestCase: {
    url: `${config.API_URL}/lqa-game/system/testcase/`,
    name: "删除测试用例",
    delete: function (moduleName) {
      return http.delete(this.url + moduleName);
    }
  },
  useHisVerTest: {
    url: `${config.API_URL}/lqa-game/system/version/useVerHisTest`,
    name: "复用历史版本测试案例信息",
    get: function (versionNum, nowVersionNum) {
      return http.get(this.url, {versionNum, nowVersionNum});
    }
  },
  useHisVerFile: {
    url: `${config.API_URL}/lqa-game/system/version/useVerHisFile`,
    name: "复用历史版本参考文件信息",
    get: function (versionNum, nowVersionNum) {
      return http.get(this.url, {versionNum, nowVersionNum});
    }
  },
  deleteAllTestCase: {
    url: `${config.API_URL}/lqa-game/system/testcase/deleteAll`,
    name: "删除测试用例",
    delete: function (versionNum) {
      return http.delete(this.url, void 0, {params: {versionNum}});
    }
  },
  deleteAllTestFile: {
    url: `${config.API_URL}/lqa-game/system/testcase/deleteAllTaskFile`,
    name: "删除任务附件",
    delete: function (versionNum) {
      return http.delete(this.url, void 0, {params: {versionNum}});
    }
  },
  deleteAllTaskFile: {
    url: `${config.API_URL}/lqa-game/system/taskFile/delete`,
    name: "删除指定任务附件",
    post: function (data) {
      return http.post(this.url, data);
    }
  },
  exportTestCase: {
    url: `${config.API_URL}/lqa-game/system/testcase/downTemplates`,
    name: "导出模板",
    get: function (versionNum) {
      return http.get(this.url, {versionNum});
    }
  },
  testCaseUpload: {
    url: `${config.API_URL}/lqa-game/system/testcase/upload`,
    name: "附件上传",
    post: function (data, config = {timeout: 500000}) {
      return http.post(this.url, data, config);
    }
  },
  createVideoSteam: {
    url: `${config.API_URL}/lqa-game/system/version/getVideoSteam`,
    name: "生成视频推流码",
    get: function (versionNum, language) {
      return http.get(this.url, {versionNum, language});
    }
  },
  languageUpload: {
    url: `${config.API_URL}/lqa-game/system/item/import`,
    name: "语言包上传",
    post: function (data, config = {timeout: 50000}) {
      return http.post(this.url, data, config);
    }
  },
  languageUploadFinal: {
    url: `${config.API_URL}/lqa-game/system/item/importData`,
    name: "语言包上传",
    post: function (data, config = {timeout: 500000}) {
      return http.post(this.url, data, config);
    }
  },
  getLanguageList: {
    url: `${config.API_URL}/lqa-game/system/item/list`,
    name: "获取语言包列表",
    get: function (query) {
      return http.get(this.url, query);
    }
  },
  getLangCounts: {
    url: `${config.API_URL}/lqa-game/system/item/getLangCounts`,
    name: "添加语言文件",
    get: function (versionNum, language) {
      return http.get(this.url, {versionNum, lang: language});
    }
  },
  deleteLangByTarget: {
    url: `${config.API_URL}/lqa-game/system/item/deleteByTarget`,
    name: "删除测试用例",
    delete: function (versionNum, language) {
      return http.delete(this.url, void 0, {params: {versionNum, targetLanguage: language}});
    }
  },
  deleteAllByVersion: {
    url: `${config.API_URL}/lqa-game/system/item/deleteByVersion`,
    name: "删除测试用例",
    delete: function (versionNum) {
      return http.delete(this.url, void 0, {params: {versionNum}});
    }
  },
  getAllLanguageInfoList: {
    url: `${config.API_URL}/lqa-game/system/item/allList`,
    name: "获取语言包列表",
    post: function (data) {
      return http.post(this.url, data);
    }
  },
  deleteLanguage: {
    url: `${config.API_URL}/lqa-game/system/item/`,
    name: "删除测试用例",
    delete: function (moduleName) {
      return http.delete(this.url + moduleName);
    }
  },
  languageUpdate: {
    url: `${config.API_URL}/lqa-game/system/item`,
    name: "修改语言文件",
    put: function (data) {
      return http.put(this.url, data);
    }
  },
  addLanguage: {
    url: `${config.API_URL}/lqa-game/system/item`,
    name: "添加语言文件",
    post: function (data) {
      return http.post(this.url, data);
    }
  },
  exportLanguageData: {
    url: `${config.API_URL}/lqa-game/system/item/export`,
    name: "导出语言文件",
    get: function (query, config = {timeout: 800000}) {
      return http.get(this.url, query, config);
    }
  },
  exportLanguageSgData: {
    url: `${config.API_URL}/lqa-game/system/item/exportSuggest`,
    name: "导出语言文件",
    get: function (query, config = {timeout: 800000}) {
      return http.get(this.url, query, config);
    }
  },


  termDataUpload: {
    url: `${config.API_URL}/lqa-game/system/termdata/upload`,
    name: "语言包上传",
    post: function (data, config = {}) {
      return http.post(this.url, data, config);
    }
  },
  getTermDataList: {
    url: `${config.API_URL}/lqa-game/system/termdata/list`,
    name: "获取语言包列表",
    get: function (query) {
      return http.get(this.url, query);
    }
  },
  deleteTerm: {
    url: `${config.API_URL}/lqa-game/system/termdata/`,
    name: "删除测试用例",
    delete: function (moduleName) {
      return http.delete(this.url + moduleName);
    }
  },
  termDataUpdate: {
    url: `${config.API_URL}/lqa-game/system/termdata`,
    name: "修改语言文件",
    put: function (data) {
      return http.put(this.url, data);
    }
  },
  addTermData: {
    url: `${config.API_URL}/lqa-game/system/termdata`,
    name: "添加语言文件",
    post: function (data) {
      return http.post(this.url, data);
    }
  },

  delAllTermData: {
    url: `${config.API_URL}/lqa-game/system/termdata/deleteALL`,
    name: "添加语言文件",
    delete: function (versionNum) {
      return http.delete(this.url, void 0, {params: {versionNum}});
    }
  },
  delAllModulaData: {
    url: `${config.API_URL}/lqa-game/system/modular/deleteAll/`,
    name: "删除所有测试点",
    delete: function (moduleName, config = {timeout: 1800000}) {
      return http.delete(this.url + moduleName, void 0, config);
    }
  },
  termFirstUpload: {
    url: `${config.API_URL}/lqa-game/system/termdata/import`,
    name: "语言包上传",
    post: function (data, config = {}) {
      return http.post(this.url, data, config);
    }
  },
  ternUploadFinal: {
    url: `${config.API_URL}/lqa-game/system/termdata/importData`,
    name: "语言包上传",
    post: function (data, config = {timeout: 800000}) {
      return http.post(this.url, data, config);
    }
  },
  //参考文件
  fileWordDataUpload: {
    url: `${config.API_URL}/lqa-game/system/word/upload`,
    name: "语言包上传",
    post: function (data, config = {}) {
      return http.post(this.url, data, config);
    }
  },
  getFileWordDataList: {
    url: `${config.API_URL}/lqa-game/system/word/list`,
    name: "获取语言包列表",
    get: function (query) {
      return http.get(this.url, query);
    }
  },
  getFileWordById: {
    url: `${config.API_URL}/lqa-game/system/word/`,
    name: "删除测试用例",
    get: function (moduleName) {
      return http.get(this.url + moduleName);
    }
  },
  getFileWordByFileName: {
    url: `${config.API_URL}/lqa-game/system/word/checkFileName?versionNum=`,
    name: "检查附件名称是否重复",
    get: function (versionNum, fileName) {
      return http.get(this.url, {versionNum, fileName});
    }
  },
  deleteFileWord: {
    url: `${config.API_URL}/lqa-game/system/word/`,
    name: "删除测试用例",
    delete: function (moduleName) {
      return http.delete(this.url + moduleName);
    }
  },
  fileWordDataUpdate: {
    url: `${config.API_URL}/lqa-game/system/word`,
    name: "修改语言文件",
    put: function (data) {
      return http.put(this.url, data);
    }
  },
  addFileWordData: {
    url: `${config.API_URL}/lqa-game/system/word`,
    name: "添加语言文件",
    post: function (data) {
      return http.post(this.url, data);
    }
  },
  addFileWordDatas: {
    url: `${config.API_URL}/lqa-game/system/word/adds`,
    name: "添加语言文件",
    post: function (data) {
      return http.post(this.url, data);
    }
  },
  //任务附件

  getTaskFileDataList: {
    url: `${config.API_URL}/lqa-game/system/taskFile/list`,
    name: "获取语言包列表",
    get: function (params) {
      return http.get(this.url, params);
    }
  },
  deleteTaskFile: {
    url: `${config.API_URL}/lqa-game/system/taskFile/`,
    name: "删除测试用例",
    delete: function (moduleName) {
      return http.delete(this.url + moduleName);
    }
  },
  taskFileDataUpdate: {
    url: `${config.API_URL}/lqa-game/system/taskFile`,
    name: "修改语言文件",
    put: function (data) {
      return http.put(this.url, data);
    }
  },
  addTaskFileData: {
    url: `${config.API_URL}/lqa-game/system/taskFile/addlist`,
    name: "添加语言文件",
    post: function (data, config = {timeout: 800000}) {
      return http.post(this.url, data, config);
    }
  },
  term: {
    getCounts: {
      url: `${config.API_URL}/lqa-game/system/termdata/getTermCounts`,
      name: "添加语言文件",
      get: function (versionNum, language) {
        return http.get(this.url, {versionNum, lang: language});
      }
    },
    deleteTerms: {
      url: `${config.API_URL}/lqa-game/system/termdata/byTarget`,
      name: "删除测试用例",
      delete: function (versionNum, language) {
        return http.delete(this.url, void 0, {params: {versionNum, targetLanguage: language}});
      }
    },
  },
  proWord: {
    getCounts: {
      url: `${config.API_URL}/lqa-game/system/word/getVersionCounts`,
      name: "添加语言文件",
      get: function (versionNum) {
        return http.get(this.url, {versionNum});
      }
    },
  },
  version: {
    getVersionDates: {
      url: `${config.API_URL}/lqa-game/system/version/getVersions`,
      name: "查询版本列表",
      get: function (projectNum) {
        return http.get(this.url, {projectNum});
      }
    },
    getSingTargetLanguage: {
      url: `${config.API_URL}/lqa-game/system/version/getTargetLanguage`,
      name: "获取目标语言",
      get: function (versionNum) {
        return http.get(this.url, {versionNum});
      }
    },
    checkVersionRole: {
      url: `${config.API_URL}/lqa-game/system/version/checkRole`,
      name: "检查版本权限",
      get: async function (versionNum) {
        return await http.get(this.url, {versionNum});
      }
    },

  }
}
